module.exports = __webpack_public_path__ + "static/media/BovExo_template_fornecedores_clientes.be5579bf.xlsx";